var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mb-4"},[(_vm.loaded)?_c('report-item',{attrs:{"report":_vm.report,"check_unique":_vm.check_unique},on:{"reportRestart":_vm.restartReport}}):_vm._e(),_vm._v(" "),(_vm.report.result && _vm.report.check_system.api_id)?_c('report-detail',{attrs:{"report":_vm.report}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }